import * as React from 'react';

const PenIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='16'
		height='16'
		fill='none'
		viewBox='0 0 16 16'>
		<g clipPath='url(#clip0_1366_2177)'>
			<g clipPath='url(#clip1_1366_2177)'>
				<path
					fill='#05386B'
					d='M12.146.145a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zm-.94 2.354L13.5 4.792l1.293-1.293L12.5 1.206zm1.587 3L10.5 3.206 4 9.706v.293h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.82 3.82-1.527.107-.106A.5.5 0 0 1 5 12.499v-.5h-.5a.5.5 0 0 1-.5-.5v-.5h-.5a.5.5 0 0 1-.468-.325'></path>
			</g>
		</g>
		<defs>
			<clipPath id='clip0_1366_2177'>
				<path
					fill='#fff'
					d='M0 0h16v16H0z'></path>
			</clipPath>
			<clipPath id='clip1_1366_2177'>
				<path
					fill='#fff'
					d='M0 0h16v16H0z'></path>
			</clipPath>
		</defs>
	</svg>
);

export default PenIcon;
